import { ContentfulPhone } from "../../../../ContentfulTypes";

interface Props {
  postpaidPhones: ContentfulPhone[];
  tablets: ContentfulPhone[];
  prepaidPhones: ContentfulPhone[];
  storedFilters: Record<string, any>;
}

const getPoints = (item) => {
  const phoneProps = item.props?.phone || item.props?.children?.props?.phone;
  return phoneProps?.highestPoints || 0;
};

const applyPCOptimumFilter = ({
  postpaidPhones,
  tablets,
  prepaidPhones,
  storedFilters,
}: Props) => {
  if (storedFilters?.standard?.['standard-offers']?.['standard-offers-pcOptimumPoints']) {
    const filterByPCPoints = (phones) => phones
      .filter((item) => {
        const highestPoints = getPoints(item);
        return highestPoints > 0;
      })
      .sort((phone1, phone2) => {
        const phone1HighestPoints = getPoints(phone1);
        const phone2HighestPoints = getPoints(phone2);
        return (phone2HighestPoints) - (phone1HighestPoints);
      });

    return {
      postpaidPhones: filterByPCPoints(postpaidPhones),
      tablets: filterByPCPoints(tablets),
      prepaidPhones: filterByPCPoints(prepaidPhones),
    };
  }
  return { postpaidPhones, tablets, prepaidPhones };
};

export default applyPCOptimumFilter;
